<template>
    <div>
  <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table :search="search" :items="wokflows" :headers="headers">
        <template v-slot:items="props">
            <td class="justify-center layout px-0">
                <v-icon class="mr-2" @click="editItem(props.item)">edit</v-icon>
                <v-icon @click="deleteItem(props.item.id)">delete</v-icon>
            </td>
            <td class="text-xs-center">
                {{ props.item.name }}
            </td>
            <td class="text-xs-center">
                {{ props.item.description }}
            </td>
        </template>
    </v-data-table>
    </div>
</template>
<script>
import Api from "@/services/Api";
export default {
    data: () => ({
        headers: [{
                text: "Action",
                align: "center",
                sortable: false
            },
            {
                text: "Name",
                align: "center",
                value: "name",
            },
            {
                text: "Description",
                align: "center",
                value: "description",
            },
        ],
        search: '',
        tab: 0,
        wokflows: []
    }),
    created() {
        this.initialise()
    },
    methods: {
        initialise() {
            Api().get('/workflows').then(res => {
                this.workflows = res.data
            })
        }
    }
}
</script>